import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ExitStrategiesProps from './ExitStrategiesProps'
import Typography from '@mui/material/Typography'
import AtrInputs from './AtrInputs'

export default function PeakValleyExitStrategyInput(props: ExitStrategiesProps) {
  const { backtestSettingInputData, handleInputChange } = props

  const [localFractal, setLocalFractal] = useState<string | null>(null)
  const [localLookback, setLocalLookback] = useState<string | null>(null)
  const [localOffset, setLocalOffset] = useState<string | null>(null)

  useEffect(() => {
    setLocalFractal(null)
  }, [backtestSettingInputData.generateTrades.fractalCount])
  useEffect(() => {
    setLocalLookback(null)
  }, [backtestSettingInputData.generateTrades.maxPeakValleyLookback])
  useEffect(() => {
    setLocalOffset(null)
  }, [backtestSettingInputData.generateTrades.priceOffset])

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-amount">Fractal left/right</InputLabel>
            <OutlinedInput
              value={
                localFractal !== null
                  ? localFractal
                  : backtestSettingInputData.generateTrades.fractalCount
              }
              name="generateTrades.fractalCount"
              onChange={(e) => setLocalFractal(e.target.value)}
              onBlur={() => {
                if (localFractal !== null) {
                  const p = parseFloat(localFractal)
                  if (!isNaN(p)) handleInputChange('generateTrades.fractalCount', p)
                  setLocalFractal(null)
                }
              }}
              type={'number'}
              inputProps={{ min: 1 }}
              id="outlined-adornment-amount"
              startAdornment={<InputAdornment position="start">#</InputAdornment>}
              label="Fractal left/right"
            />
          </FormControl>
        </Grid>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-amount">Max candles lookback</InputLabel>
            <OutlinedInput
              value={
                localLookback !== null
                  ? localLookback
                  : backtestSettingInputData.generateTrades.maxPeakValleyLookback
              }
              name="generateTrades.maxPeakValleyLookback"
              onChange={(e) => setLocalLookback(e.target.value)}
              onBlur={() => {
                if (localLookback !== null) {
                  const p = parseFloat(localLookback)
                  if (!isNaN(p)) handleInputChange('generateTrades.maxPeakValleyLookback', p)
                  setLocalLookback(null)
                }
              }}
              type={'number'}
              inputProps={{ min: 1 }}
              id="outlined-adornment-amount"
              startAdornment={<InputAdornment position="start">#</InputAdornment>}
              label="Max candles lookback"
            />
          </FormControl>
        </Grid>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Price offset</InputLabel>
            <OutlinedInput
              value={
                localOffset !== null
                  ? localOffset
                  : backtestSettingInputData.generateTrades.priceOffset
              }
              name="generateTrades.priceOffset"
              onChange={(e) => setLocalOffset(e.target.value)}
              onBlur={() => {
                if (localOffset !== null) {
                  const p = parseFloat(localOffset)
                  if (!isNaN(p)) handleInputChange('generateTrades.priceOffset', p)
                  setLocalOffset(null)
                }
              }}
              type={'number'}
              inputProps={{ step: 0.00001, min: 0 }}
              label="Price offset"
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Typography variant={'body2'}>* Fallback when no fractal found:</Typography>
      </Grid>

      <Grid item xs={12}>
        <AtrInputs
          onATRPeriodChange={(val) => handleInputChange('generateTrades.atrPeriod', val)}
          onChartPeriodChange={(val) => handleInputChange('generateTrades.atrChartPeriod', val)}
          onChartTimeframeChange={(val) =>
            handleInputChange('generateTrades.atrChartTimeframe', val)
          }
          atrPeriod={backtestSettingInputData.generateTrades.atrPeriod}
          chartPeriod={backtestSettingInputData.generateTrades.atrChartPeriod}
          chartTimeframe={backtestSettingInputData.generateTrades.atrChartTimeframe}
        />
      </Grid>
    </>
  )
}
